// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-me {
  /* custom scrollbar */
}
.page-me::-webkit-scrollbar {
  width: 12px;
  box-shadow: inset 2px 1px 4px -1px rgba(0, 0, 0, 0.5);
}
.page-me::-webkit-scrollbar-track {
  background-color: transparent;
}
.page-me::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumb);
  border: 6px solid transparent;
}
.page-me::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scrollbar-thumbHover);
}

.page-me:hover::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumbActive);
  border: 6px solid transparent;
}
.page-me::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scrollbar-thumbHover);
}

.page-me {
  color: var(--color-text);
  overflow: auto;
}
.page-me .me-content {
  display: flex;
  flex-direction: row;
  gap: 44px;
  margin-inline: auto;
  max-width: 1200px;
  height: 100%;
}
.page-me .me-content .content-about {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 40px 0;
  min-width: 590px;
}
.page-me .me-content .content-about .about-header {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.page-me .me-content .content-about .about-header .header-name {
  font-size: 58px;
  font-family: Ubuntu-M, sans-serif;
}
.page-me .me-content .content-about .about-header .header-title {
  font-size: 24px;
  font-family: Ubuntu-M, sans-serif;
}
.page-me .me-content .content-about .about-header .header-info {
  font-size: 24px;
  font-family: Ubuntu-L, sans-serif;
  opacity: 0.4;
}
.page-me .me-content .content-about .about-header .header-img {
  margin-top: 40px;
  display: flex;
  border-radius: 100%;
  background: #9366ef;
  width: 240px;
  height: 240px;
  align-items: center;
  justify-content: center;
}
.page-me .me-content .content-about .about-header .header-img img {
  height: 98%;
  border-radius: 100%;
  filter: grayscale(0.8);
}
.page-me .me-content .content-about .about-header .header-img img:hover {
  filter: grayscale(0);
}
.page-me .me-content .content-about .about-use {
  display: flex;
  flex-direction: column;
}
.page-me .me-content .content-about .about-use svg {
  font-size: 40px;
  opacity: 0.4;
}
.page-me .me-content .content-me {
  display: flex;
  flex-direction: column;
  gap: 40px;
  overflow: auto;
  scrollbar-width: none;
}
.page-me .me-content .content-me .me-info {
  font-family: Ubuntu-L, sans-serif;
  margin-top: 40px;
  padding: 12px;
}
.page-me .me-content .content-me .me-history {
  margin-bottom: 40px;
  display: flex;
  gap: 18px;
  flex-direction: column;
  flex-wrap: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/theme/scrollbar.scss","webpack://./src/pages/me/me.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;ACCF;ADAE;EACE,WAAA;EAGA,qDAAA;ACEJ;ADCE;EACE,6BAAA;ACCJ;ADEE;EACE,8CAAA;EACA,6BAAA;ACAJ;ADGE;EACE,mDAAA;ACDJ;;ADME;EACE,oDAAA;EACA,6BAAA;ACHJ;ADME;EACE,mDAAA;ACJJ;;AAxBA;EACE,wBAAA;EACA,cAAA;AA2BF;AAvBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EAEA,YAAA;AAwBJ;AAtBI;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;AAwBN;AAtBM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAwBR;AAtBQ;EACE,eAAA;EACA,iCAAA;AAwBV;AArBQ;EACE,eAAA;EACA,iCAAA;AAuBV;AApBQ;EACE,eAAA;EACA,iCAAA;EACA,YAAA;AAsBV;AAlBQ;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAoBV;AAlBU;EACE,WAAA;EACA,mBAAA;EACA,sBAAA;AAoBZ;AAjBU;EACE,oBAAA;AAmBZ;AAdM;EACE,aAAA;EACA,sBAAA;AAgBR;AAdQ;EACE,eAAA;EACA,YAAA;AAgBV;AAXI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,cAAA;EACA,qBAAA;AAYN;AAVM;EACE,iCAAA;EACA,gBAAA;EACA,aAAA;AAYR;AATM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;AAWR","sourcesContent":["%scrollbar {\n  /* custom scrollbar */\n  &::-webkit-scrollbar {\n    width: 12px;\n    -webkit-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    -moz-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumb);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}\n\n%scrollbarHover {\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumbActive);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}","@import '../../theme/scrollbar.scss';\n\n.page-me {\n  color: var(--color-text);\n  overflow: auto;\n\n  @extend %scrollbar;\n\n  .me-content {\n    display: flex;\n    flex-direction: row;\n    gap: 44px;\n    margin-inline: auto;\n    max-width: 1200px;\n\n    height: 100%;\n\n    .content-about {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      margin: 40px 0;\n      min-width: 590px;\n\n      .about-header {\n        display: flex;\n        flex-direction: column;\n        gap: 18px;\n\n        .header-name {\n          font-size: 58px;\n          font-family: Ubuntu-M, sans-serif;\n        }\n\n        .header-title {\n          font-size: 24px;\n          font-family: Ubuntu-M, sans-serif;\n        }\n\n        .header-info {\n          font-size: 24px;\n          font-family: Ubuntu-L, sans-serif;\n          opacity: 0.4;\n        }\n\n\n        .header-img {\n          margin-top: 40px;\n          display: flex;\n          border-radius: 100%;\n          background: #9366ef;\n          width: 240px;\n          height: 240px;\n          align-items: center;\n          justify-content: center;\n\n          img {\n            height: 98%;\n            border-radius: 100%;\n            filter: grayscale(0.8);\n          }\n\n          img:hover {\n            filter: grayscale(0);\n          }\n        }\n      }\n\n      .about-use {\n        display: flex;\n        flex-direction: column;\n  \n        svg {\n          font-size: 40px;\n          opacity: 0.4;\n        }\n      }\n    }\n\n    .content-me {\n      display: flex;\n      flex-direction: column;\n      gap: 40px;\n\n      overflow: auto;\n      scrollbar-width: none;\n\n      .me-info {\n        font-family: Ubuntu-L, sans-serif;\n        margin-top: 40px;\n        padding: 12px;\n      }\n\n      .me-history {\n        margin-bottom: 40px;\n        display: flex;\n        gap: 18px;\n        flex-direction: column;\n        flex-wrap: nowrap;\n      }\n    }\n  }\n}\n\n.page-me:hover {\n  @extend %scrollbarHover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
